import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function cancelVisit(registerId, unitId) {
  const response = await http
    .postData(`/perjalanan-pasien/visit-cancel`, {
      register_id: registerId,
      unit_id: unitId
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function undoCancelVisit(registerId, unitId) {
  const response = await http
    .putData(`/perjalanan-pasien/visit-cancel`, {
      register_id: registerId,
      unit_id: unitId
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function setPasienArived(date, registerId, unitId) {
  const response = await http
    .putData(
      `/visit-pasien-klinik/tanggal/${date}/register/${registerId}/klinik/${unitId}`,
      {
        status: "datang"
      }
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function setPasienNotArived(date, registerId, unitId) {
  const response = await http
    .putData(
      `/visit-pasien-klinik/tanggal/${date}/register/${registerId}/klinik/${unitId}`,
      {
        status: "batal"
      }
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function setPasienUnconfirmed(date, registerId, unitId) {
  const response = await http
    .putData(
      `/visit-pasien-klinik/tanggal/${date}/register/${registerId}/klinik/${unitId}`,
      {
        status: null
      }
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function setPasienAntrianChannel(date, registerId, unitId, ch = "") {
  const response = await http
    .putData(
      `/visit-pasien-klinik/tanggal/${date}/register/${registerId}/klinik/${unitId}/info-antrian`,
      {
        q_type: ch
      }
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  cancelVisit,
  undoCancelVisit,
  setPasienArived,
  setPasienNotArived,
  setPasienUnconfirmed,
  setPasienAntrianChannel
};
